import { heroMetrics } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="w-full bg-background-50">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-stretch gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:py-24">
        <div className="flex flex-col justify-center">
          <div className="mb-6 flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold tracking-[0.2em] text-primary-700">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              安全验证专号
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-verified-badge-line" />
              官方核验
            </span>
          </div>

          <h1 className="font-heading text-5xl font-black leading-[1.05] tracking-tight text-foreground-950 md:text-6xl lg:text-7xl">
            黑料地址
            <span className="mt-3 block font-heading text-2xl font-bold text-primary-600 md:text-3xl">
              安全吗 · 真假辨别 · 靠谱吗
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-balance text-base leading-relaxed text-foreground-700 md:text-lg">
            在真假难辨的入口之间，我们只做一件事：把可信的官方验证方式与辨别方法讲清楚。识别钓鱼网站、确认官方入口，<strong className="font-semibold text-foreground-950">黑料地址安全吗</strong>，答案是可以被逐项核对的。
          </p>

          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            无论是判断<strong className="font-medium text-foreground-900">真假辨别</strong>，还是评估一个入口到底<strong className="font-medium text-foreground-900">靠谱吗</strong>，这里都给出可操作的核对步骤，而不是一句空口保证。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#verify"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-shield-check-line text-base" />
              查看官方验证入口
            </a>
            <a
              href="#guide"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-route-line text-base" />
              了解真假辨别方法
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6 md:gap-6">
            {heroMetrics.map((m) => (
              <div key={m.label}>
                <dt className="font-heading text-2xl font-black text-primary-600 md:text-3xl">
                  {m.value}
                  <span className="ml-0.5 text-sm font-bold text-accent-600">{m.unit}</span>
                </dt>
                <dd className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{m.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative w-full">
          <div className="relative h-[420px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[560px] lg:h-full lg:min-h-[620px]">
            <img
              src="https://readdy.ai/api/search-image?query=stylized%20editorial%20magazine%20cover%20artwork%20with%20dramatic%20crimson%20and%20gold%20abstract%20shapes%2C%20layered%20paper%20texture%2C%20bold%20graphic%20composition%2C%20warm%20cream%20background%2C%20elegant%20print%20aesthetic%2C%20high%20contrast%2C%20art%20poster&width=1000&height=1200&seq=hero-cover-magazine-01&orientation=portrait"
              alt="黑料地址安全验证特辑封面"
              title="黑料地址 安全验证 真假辨别 封面"
              className="h-full w-full animate-slow-zoom object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-foreground-950/10 to-transparent" />

            <div className="absolute left-5 top-5 flex items-center gap-2 rounded-full bg-background-50/95 px-3 py-1.5 text-xs font-semibold text-primary-700">
              <i className="ri-shield-star-line" />
              官方验证
            </div>

            <div className="absolute right-4 top-5 hidden items-center rounded-full bg-accent-500 px-3 py-1.5 text-xs font-bold text-foreground-950 md:flex">
              第 09 期 · 封面故事
            </div>

            <div className="absolute bottom-5 left-5 right-5">
              <p className="font-heading text-lg font-bold leading-snug text-background-50 md:text-xl">
                先验证，再访问
              </p>
              <p className="mt-1 text-xs leading-relaxed text-background-100 md:text-sm">
                每一次点击，都值得先花十秒核对入口真伪。
              </p>
            </div>
          </div>

          <div className="absolute -bottom-4 right-4 hidden items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 lg:flex">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-fingerprint-line text-lg" />
            </span>
            <span className="text-xs leading-tight text-foreground-700">
              已收录 16 类钓鱼手法
              <br />
              <span className="text-foreground-500">每日比对更新</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}